import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { CharitiesList } from '../charity/';
import { CharityAdd } from '../charity/CharityAdd';
import { CharityEdit } from '../charity/CharityEdit';
import NavigationLinks  from '../layout/NavigationLinks';
import { Home } from '../home/';
import { DonationsList } from '../donation/DonationsListContainer';
import { CharityRegister } from '../charity/register';
import { CharityProfile } from '../charity-profile/';
import { CampaignAdd, CampaignEdit, CampaignsList } from '../campaign';
import { PlacementEdit, PlacementsList } from '../placement';
import WizardForm from '../onboarding/WizardForm';
import dashboard from '../dashboard';
import Profile from '../profile'
import ResetPassword from '../auth/reset-password'

class Application extends React.Component<any> {
  public render() {
    const { auth, signOut, home } = this.props;
    return (
      <BrowserRouter>
        <div className={`${auth.status !== 'SIGNED_IN' ? 'login-page register-page' : ''}`} style={{backgroundColor: '#f4f5f9', boxSizing: 'unset'}}>
          {/* <div className="container is-widescreen"> */}
            <NavigationLinks auth={auth} signOut={signOut} home={home}/>
          <div style={{padding: '0 8%'}}>
          <Route exact={true} path="/" component={Home}/>
          <Route exact={true} path="/reset" component={ResetPassword}/>
          <div>
            {
              auth.status === 'ANONYMOUS' &&
              <div>
                <Switch>
                  <Route path="/register" component={CharityRegister}/>
                </Switch>
              </div>
            }
            {
              (auth.status === 'SIGNED_IN' && auth.isAdmin) &&
              <Switch>
                <Route path="/charities/add" component={CharityAdd}/>
                <Route path="/charities/edit/:uid" component={CharityEdit}/>
                <Route path="/charities" component={CharitiesList}/>
                <Route path="/campaigns/edit/:uid" component={CampaignEdit}/>
                <Route path="/campaigns/add" component={CampaignAdd}/>
                <Route path="/campaigns" component={CampaignsList}/>
                {/* <Route path="/placements/edit/:uid" component={PlacementEdit}/> */}
                {/* <Route path="/placements" component={PlacementsList}/> */}
                <Route path="/donations" component={DonationsList}/>
                <Route path="/dashboard" component={dashboard}/>
                <Route path="/profile" component={Profile}/>
              </Switch>
            }
            {
              (auth.status === 'SIGNED_IN' && !auth.isAdmin) &&
              <Switch>
                <Route path="/charities/edit/:uid" component={CharityEdit}/>
                <Route path="/donations" component={DonationsList}/>
                <Route path="/campaigns/edit/:uid" component={CampaignEdit}/>
                <Route path="/campaigns/add" component={CampaignAdd}/>
                <Route path="/campaigns" component={CampaignsList}/>
                <Route path="/onboarding" component={WizardForm}/>
                <Route path="/payments" component={CharityProfile}/>
                <Route path="/dashboard" component={dashboard}/>
                <Route path="/profile" component={Profile}/>
              </Switch>
            }
            {
              auth.status !== 'ANONYMOUS' &&
              <footer>
                Copyright © 2018 Donaco, All rights reserved.
              </footer>
            }
          </div>
        </div>
        </div>
      </BrowserRouter>
    );
  }
}

export { Application };
